import React from 'react';
import Box from '@bit/knotchinc.web-react-components.box';
import { LeftContainer } from 'helpers/styles.js';
import {
  StyledErrorCardContainer,
  StyledErrorCardContentContainer,
  EmptyContentBar,
  EmptyEntityIcon,
  ErrorCardText,
} from './styled.js';

const ErrorContentCard = () => (
  <StyledErrorCardContainer>
    <StyledErrorCardContentContainer>
      <LeftContainer>
        <Box width="100%" textAlign="left">
          <EmptyEntityIcon />
          <EmptyEntityIcon />
          <ErrorCardText>No content found.</ErrorCardText>
          <EmptyContentBar />
          <EmptyContentBar />
          <EmptyContentBar width="116px" />
        </Box>
      </LeftContainer>
    </StyledErrorCardContentContainer>
  </StyledErrorCardContainer>
);

export default ErrorContentCard;
